import React, { useContext, useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import CardWidget, { Colors } from '../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import { DailyMonitoringFiltersContext } from '../../../../context/DailyMonitoringFiltersContext'
import { ORDER_STATUS } from '../../../../types/Order'

const GET_DATA = gql`
  query OrdersFinishedCounter($filters: JSON) {
    ordersCount(
      filters: $filters,
      query: {
        bool: {
          filter: [
            {
              range: {
                created_at: {
                  gte: "now/d",
                  lte: "now/d",
                  format: "yyyy-MM-d",
                  time_zone: "-03:00"
                }
              }
            },
            {
              term: {
                new_status: "${ORDER_STATUS.CANCELLED}"
              }
            }
          ]
        }
      }
    )
  }
`

const TodaysOrdersCanceled = (): JSX.Element => {
  const { filters } = useContext(DailyMonitoringFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_DATA, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <CardWidget title="Pedidos cancelados hoje" number={data.ordersCount} color={Colors.red} />
  )
}

export default TodaysOrdersCanceled
